export default "https://cdn-static.gokick.com/assets/ba7f9a5518cadaf73eb1329111c0735c5df64124/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";